import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_prairie-grains/artifacts/4rxtb62e_Robert%20-Good%20Grains.jpg";

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1600&auto=format&fit=crop&q=80"
          alt="Montana wheat field at golden hour"
          className="w-full h-full object-cover"
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#3B2F1E]/90 via-[#3B2F1E]/40 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#2D5016]/30 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20">
        <div className="animate-fade-in-up">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img 
              src={LOGO_URL}
              alt="Good Grains Logo"
              className="w-32 h-32 md:w-40 md:h-40 rounded-full object-cover shadow-2xl border-4 border-[#D4A84B] ring-4 ring-white/20"
              style={{ imageRendering: 'crisp-edges' }}
            />
          </div>

          {/* Label */}
          <span className="inline-block px-4 py-2 rounded-full bg-[#D4A84B]/20 border border-[#D4A84B]/40 text-[#D4A84B] text-sm font-medium uppercase tracking-widest mb-6">
            Organic & Non-GMO Animal Feed
          </span>

          {/* Main Headline */}
          <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight">
            Good Grains
          </h1>

          {/* Subheadline */}
          <p className="text-xl sm:text-2xl md:text-3xl text-white/90 font-light mb-10 max-w-2xl mx-auto">
            Healthy Feeds Your Animals Will Love
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/shop"
              className="px-8 py-4 rounded-lg bg-[#A0522D] text-white font-semibold text-lg hover:bg-[#8B4513] transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5"
            >
              Shop Feed
            </Link>
            <Link
              to="/about"
              className="px-8 py-4 rounded-lg border-2 border-white/50 text-white font-semibold text-lg hover:bg-white/10 transition-all duration-300 hover:-translate-y-0.5"
            >
              Learn Our Story
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <ChevronDown className="w-8 h-8 text-white/70" />
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#FAF6F0] to-transparent" />
    </section>
  );
};

export default HeroSection;
